<template>
  <div class="bill-list-page">
    <transactions-page-controls
      :is-transactions-loading="isBillsLoading"
      :stats-abac="{ data: 'bills-statisitcs', action: 'read' }"
      :stats="billsStats"
      :is-filter-active="filterActive"
      :filter-object="filterObject"
      :available-filter-types="$options.AVAILABLE_FILTER_TYPES"
      :additional-filters="$options.ADDITIONAL_FILTERS"
      @filterChanged="handleFilterChanged"
      @export="exportBills"
      @refresh="loadBills"
    >
      <template #extraFilter>
        <bill-types-select
          :selected-type="selectedBillType"
          @typeChanged="handleBillTypeChanged"
        ></bill-types-select>
      </template>
      <template #specificActions>
        <primary-button
          class="bills-actions-bar__create-bill"
          :label="$t('bills.actions.create')"
          @click="handleCreateBillAction"
        ></primary-button>
        <!--        <require-access action="read" data="bills-make">-->
        <!--          -->
        <!--        </require-access>-->
      </template>
    </transactions-page-controls>
    <company-bills-table-v2
      :is-transactions-loading="isBillsLoading"
      :bill-type="selectedBillType"
      class="company-bills__table"
      :transactions-list="billsTransactions"
    ></company-bills-table-v2>
  </div>
</template>

<script>
import { ADD_EXPORT } from '@vue-app/store/const/actions-types'
import { CompaniesApi } from '@js-app/office/api/companies-api'
import moment from 'moment'
import responsiveMixin from '@vue-app/mixins/responsive-mixin'

import { mapGetters, mapState } from 'vuex'
import { RouteHelper } from '@js-app/services/helpers/routes/routes-helper'
import { BILL_TYPES } from '@js-app/const/bill-types'
import CompanyBillsTableV2 from '@vue-app/components/company/bills/table/CompanyBillsTableV2.vue'
import { getCookie, setCookie } from '@js-app/services/helpers/cookie'
import RequireAccess from '@vue-app/components/base/role-based/RequireAccess.vue'
import TransactionsPageControls from '@vue-app/components/company/transactions/shared/transactions-page-controls/TransactionsPageControls.vue'
import BillTypesSelect from '@vue-app/components/company/bills/filter/BillTypeSelect.vue'
import { Stats } from '@js-app/entities/transaction/Stats'
import PrimaryButton from '@vue-app/components/base/button/PrimaryButton.vue'
import {
  ADDITIONAL_FILTERS,
  AVAILABLE_FILTER_TYPES,
} from '@js-app/const/transactions-filters'

export default {
  name: 'BillListPage',
  components: {
    PrimaryButton,
    BillTypesSelect,
    TransactionsPageControls,
    RequireAccess,
    CompanyBillsTableV2,
  },
  props: {},
  mixins: [responsiveMixin],
  DEFAULT_FILTER_OBJECT: {
    dates: {
      from: moment().subtract(1, 'days').toDate(),
      to: moment().toDate(),
    },
    currentFilterType: null,
    activeFilters: {},
  },
  data() {
    return {
      showStatisticBlock: false,
      showFilterBlock: false,
      billsStats: new Stats(),
      billsTransactions: [],
      filterActive: false,
      selectedBillType: BILL_TYPES[0],
      isBillsLoading: false,
      filterObject: null,
      currentView: 'bills',
    }
  },

  AVAILABLE_FILTER_TYPES,
  ADDITIONAL_FILTERS,

  computed: {
    ...mapGetters(['exportExisted']),
    ...mapState(['selectedCompany']),
    activeFilters() {
      const _filters = {}
      const activeFilters = this.filterObject?.activeFilters || {}

      for (const _filterKey in activeFilters) {
        const filter = activeFilters[_filterKey]

        if (!filter) continue

        let value =
            filter.filterValue !== undefined && filter.filterValue !== null
                ? filter.filterValue
                : filter

        if (_filterKey === 'cardPan') {
          if (/\*/.test(value)) {
            value = value.replace(/\*+/g, '%')
          }
        }

        _filters[_filterKey] = value

        if (_filterKey === 'status' && _filters[_filterKey]?.statuses) {
          _filters[_filterKey] = _filters[_filterKey].statuses
        }
      }

      return _filters
    },
  },
  watch: {
    filterObject: {
      deep: true,
      handler: 'loadBills',
    },
    selectedCompany: {
      deep: true,
      handler: 'startupPage',
      immediate: true,
    },
  },
  methods: {
    startupPage() {
      try {
        let _billsFilter = JSON.parse(
          getCookie(`bills.filter.${this.selectedCompany}`)
        )

        if (_billsFilter) {
          this.filterObject = _billsFilter
          this.filterActive = true
        } else {
          this.filterObject = this.$options.DEFAULT_FILTER_OBJECT
        }
      } catch (e) {
        console.info('bills_filters_not_found')
      } finally {
      }
    },
    async loadBills() {
      if (this.isBillsLoading) {
        return false
      }

      this.isBillsLoading = true
      try {
        let _filters = { ...this.activeFilters }

        if (this.selectedBillType) {
          _filters['operation_type_id'] = this.selectedBillType.operationTypes
        }

        let _billsDataResponse = await CompaniesApi.getCompanyBills(
          this.selectedCompany,
          {
            date_from: moment(this.filterObject.dates.from).format(
              'YYYY-MM-DD 00:00:00'
            ),
            date_to: moment(this.filterObject.dates.to).format(
              'YYYY-MM-DD 23:59:59'
            ),
            filters: _filters,
          }
        )

        this.billsStats = new Stats(_billsDataResponse.data.Stats)
        this.billsTransactions = _billsDataResponse.data.ReportOperations || []
      } catch (e) {
        this.billsTransactions = []
        console.error('failed load analytics data', e)
      } finally {
        this.isBillsLoading = false
      }
    },
    handleBillTypeChanged(billType) {
      this.selectedBillType = billType
    },
    handleFilterChanged(newFilterObject, changeType) {
      this.filterObject = { ...newFilterObject }

      this.filterActive = changeType === 'apply'

      if (changeType === 'reset') {
        setCookie(`bills.filter.${this.selectedCompany}`, null, 0)
      } else if (changeType === 'apply') {
        setCookie(
          `bills.filter.${this.selectedCompany}`,
          JSON.stringify(this.filterObject),
          0.5
        )
      }
    },
    async exportBills(exportType) {
      let _filtersForExport = { ...this.activeFilters }

      if (this.selectedBillType) {
        _filtersForExport['operation_type_id'] =
          this.selectedBillType.operationTypes
      }

      let requestObject = {
        date_from: moment(this.filterObject.dates.from).format(
          'YYYY-MM-DD 00:00:00'
        ),
        date_to: moment(this.filterObject.dates.to).format(
          'YYYY-MM-DD 23:59:59'
        ),
        filters: _filtersForExport,
        type: exportType.id,
      }

      let _filterString = JSON.stringify(requestObject)

      if (this.exportExisted('bills', _filterString)) {
        return
      }

      let _billsExportResponse = await CompaniesApi.exportCompanyBills(
        this.selectedCompany,
        requestObject
      )

      await this.$store.dispatch(ADD_EXPORT, {
        ..._billsExportResponse.data,
        section: 'bills',
        filterString: _filterString,
      })
    },
    handleCreateBillAction() {
      this.$router.push({
        name: 'company-bills-create',
        params: {
          companyId: this.selectedCompany,
        },
      })
      // this.$router.push(
      //   RouteHelper.getRoute("bill-create-base", {
      //     companyId: this.selectedCompany,
      //   })
      // );
    },
    switchView(view) {
      this.currentView = view
    },
  },
}
</script>

<style lang="scss" scoped>
.company-bills {
  &__actions-bar {
    margin-top: 30px;
  }

  &__statistic {
    margin-top: 15px;
  }

  &__filters {
    margin-top: 15px;
  }

  &__table {
    margin-top: 10px;
  }
}
</style>
